/*
 * Mime types source:
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Complete_list_of_MIME_types
 *
 * Below were the values before change the constant for Karate
 * fileName: 'Filename exceeds 100 characters',
 * fileSize: 'File exceeds 20MB limit',
 * fileType: 'Unsupported file type',
 * apiRequest: 'Upload connection failed',
 */

const ATTACHMENT_UPLOAD_ERROR_TEXT = {
  fileName: '100',
  fileSize: '20MB',
};

/*
 * Mime types source:
 * https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Complete_list_of_MIME_types
 *
 *  Below were the values before change the constant for Karate
 *  defaultDisplayText: '20MB / File',
 *  maxNumber: 'Maximum of 5 files per comment',
 *  maxSize: '20MB per file attachment',
 *  fileType: 'Certain file types will be restricted due to security concerns. These include .exe and various others.',
 */

const ATTACHMENTS_INFO_TEXT = {
  defaultDisplayText: '20MB /',
  maxNumber: '5',
  maxSize: '20MB',
};

const MAX_FILE_SIZE = 20000000;

const MAX_UPLOAD_LIMIT = 5;

const S3_TEMPLATE_URL =
  'https://s3.us-east-2.amazonaws.com/ctui-file-cache/reachTemplates.json';

const VALID_CERTIFICATE_EXTENSIONS = ['crt', 'pem', 'key', 'cer'];

export {
  ATTACHMENT_UPLOAD_ERROR_TEXT,
  ATTACHMENTS_INFO_TEXT,
  MAX_FILE_SIZE,
  MAX_UPLOAD_LIMIT,
  S3_TEMPLATE_URL,
  VALID_CERTIFICATE_EXTENSIONS,
};
